import { Component } from '@angular/core';

@Component({
  selector: 'app-search-ticket-by-number-widget',
  templateUrl: './search-ticket-by-number-widget.component.html',
  styleUrls: ['./search-ticket-by-number-widget.component.scss'],
  standalone: false,
})
export class SearchTicketByNumberWidgetComponent {
  findTicketText;

  findTicketByNumerOrID() {
    if (this.findTicketText && this.findTicketText.length < 10) {
      this.findTicketText = this.findTicketText.padStart(10, '0');
    }

    window.open(window.location.origin + '/v3ndor/chamados/' + this.findTicketText, '_blank');
  }
}
